// 🔒
import { Link } from "react-router";

export default function TrainerCard({ trainer }) {
  return (
    <Link to={`/${trainer.slug}`} className="trainer-card trainer-card--link">
      <article>
        <div className="trainer-card__top">
          <img
            src={trainer.image}
            alt={trainer.name}
            className="trainer-card__image"
          />

          <div className="trainer-card__intro">
            <h3>{trainer.name}</h3>
            <p className="trainer-card__subtitle">{trainer.role}</p>
          </div>
        </div>

        <p className="trainer-card__description">{trainer.description}</p>

        <div className="trainer-card__tags">
          {trainer.specialties.map((item) => (
            <span key={item} className="tag">
              {item}
            </span>
          ))}
        </div>

        <div className="trainer-card__stats">
          <div className="trainer-card__statBox">
            <span className="trainer-card__statNumber">{trainer.experience}</span>
            <span className="trainer-card__statLabel">Years</span>
          </div>

          <div className="trainer-card__statBox">
            <span className="trainer-card__statNumber">{trainer.clients}</span>
            <span className="trainer-card__statLabel">Clients</span>
          </div>

          <div className="trainer-card__statBox">
            <span className="trainer-card__statNumber">{trainer.programs}</span>
            <span className="trainer-card__statLabel">Programs</span>
          </div>
        </div>
      </article>
    </Link>
  );
}
// 🔒